'use client';

import ProxyImage from '@shared/ProxyImage/ProxyImage';
import Link from 'next/link';

import {TAutoupdatePage} from '@web-landing/strapi/types';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {EVENTS} from '@web-landing/analytics/events';

import styles from './AutoupdateBanner.module.scss';

type Props = Pick<
  TAutoupdatePage,
  | 'banner_leftImage'
  | 'banner_buttonText'
  | 'banner_title'
  | 'banner_rightImage'
  | 'banner_description'
>;

export const AutoupdateBanner = ({
  banner_buttonText,
  banner_description,
  banner_leftImage,
  banner_rightImage,
  banner_title,
}: Props) => {
  const onClick = () => {
    logTmrEvent(EVENTS.downloadClick, {
      pageURL: document.location.pathname,
      location: 'bottom',
    });
  };

  return (
    <div className={styles.banner}>
      <ProxyImage
        imageData={banner_leftImage}
        className={styles.banner__leftImage}
      />
      <h2 className={styles.banner__title}>{banner_title}</h2>
      <span className={styles.banner__description}>{banner_description}</span>
      <Link
        onClick={onClick}
        href="/instruction"
        className={styles.banner__link}
      >
        {banner_buttonText}
      </Link>
      <ProxyImage
        imageData={banner_rightImage}
        className={styles.banner__rightImage}
      />
    </div>
  );
};
